import { BaseDialog } from '@crehana/compass.ui';
import cn from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export var PlayroomDialog = function PlayroomDialog(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    disableBackdropClick = _ref.disableBackdropClick,
    disabledScrollLock = _ref.disabledScrollLock,
    disableEscapeKeyDown = _ref.disableEscapeKeyDown,
    children = _ref.children,
    dataTestid = _ref['data-testid'],
    className = _ref.className,
    style = _ref.style;
  return /*#__PURE__*/_jsx(BaseDialog, {
    open: open,
    disabledScrollLock: disabledScrollLock,
    disableEscapeKeyDown: disableEscapeKeyDown,
    disableBackdropClick: disableBackdropClick,
    onDismiss: onClose,
    "data-testid": dataTestid,
    className: className,
    style: style,
    children: /*#__PURE__*/_jsx("div", {
      className: cn(
      // Scope
      'compass',
      // Size
      'tw-w-full tw-max-w-6xl tw-rounded-1 tw-z-7 tw-overflow-hidden',
      // Background
      'tw-bg-neutral-light-100 dark:tw-bg-neutral-dark-800 tw-shadow-01',
      // Fonts
      'tw-text-neutral-dark-800'),
      children: children
    })
  });
};